import React, {useMemo} from 'react';

import {CellValueMarkdown} from '../../../Browse2/CellValueMarkdown';
import {ValueViewMarkdown} from '../../pages/CallPage/ValueViewMarkdown';
import {useFileContent} from '../../pages/wfReactInterface/tsDataModelHooks';
import {type CustomWeaveTypePayload} from '../customWeaveType.types';

type MarkdownViewProps = {
  entity: string;
  project: string;
  mode?: string;
  data: CustomWeaveTypePayload<'rich.markdown.Markdown', {'markup.md': string}>;
};

export const MarkdownView = ({
  entity,
  project,
  mode,
  data,
}: MarkdownViewProps) => {
  const inlineMarkup = data.val?.markup;
  const markdownFileDigest: string | undefined = data.files?.['markup.md'];
  const markdownBinary = useFileContent({
    entity,
    project,
    digest: markdownFileDigest,
    skip: !markdownFileDigest || inlineMarkup,
  });
  const markup = useMemo(() => {
    if (inlineMarkup) {
      return inlineMarkup;
    }
    return markdownBinary.result
      ? new TextDecoder().decode(markdownBinary.result)
      : null;
  }, [markdownBinary.result, inlineMarkup]);
  if (!markup) {
    return null;
  }
  if (mode === 'object_viewer') {
    return <ValueViewMarkdown value={markup} />;
  }
  return <CellValueMarkdown value={markup} />;
};
